import React, { Component } from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import CustomPagination from '../../../CustomPagination';
import CommonTable from '../../../CommonTable/CommonTable';
import TableAction from '../../../CommonTable/TableAction';
import Loader from '../../../Loader/Loader';

import { deleteWhyHostReview } from '../../../../actions/siteadmin/WhyHostReview/deleteWhyHostReview';
import messages from '../../../../locale/jsonMessages';
import reviewsManagement from './reviewsManagement.graphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';
import { withQuery } from '../../../../hoc/withGraphql';
import { dynamicAdminReviewValue } from '../../../../helpers/GetDynamicItemName/dynamicHomeValue';

import bt from '../../../../components/commonStyle.css';
import s from './AdminReviewsManagement.css';

class AdminReviewsManagement extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      currentPage: 1,
      searchList: '',
    }
  }

  setStateVariable(variables) {
    this.setState(variables)
  }

  paginationData = (currentPage) => {
    const { reviewsManagement: { refetch } } = this.props;
    let variables = { currentPage };
    this.setStateVariable({ currentPage });
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const { reviewsManagement: { refetch } } = this.props;
    let variables = {
      currentPage: 1,
      searchList: e?.target?.value,
    };
    this.setStateVariable(variables);
    refetch(variables);
  }

  deleteReview = async ({ reviewId }) => {
    const { deleteWhyHostReview, demoRestriction } = this.props;
    const { currentPage } = this.state;
    const { reviewsManagement: { refetch, getWhyHostAllReviews } } = this.props;
    let variables = { currentPage: currentPage > 1 && getWhyHostAllReviews?.results?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    const response = await deleteWhyHostReview({ reviewId });
    if (response?.status == 200) {
      await this.setStateVariable({ currentPage: variables?.currentPage });
      await refetch(variables);
    }
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.userNameLabel) },
      { data: formatMessage(messages.reviewContentLabel) }
    ]
  };


  tbody = (props) => {
    const { reviewsManagement: { getWhyHostAllReviews } } = props;
    const { locale } = this.props.intl;

    return getWhyHostAllReviews?.results?.map(value => {
      const { userName, reviewContent } = dynamicAdminReviewValue(value, locale)
      return {
        id: value?.id,
        data: [
          { data: value?.id, },
          {
            data: <div className={cx(bt.displayFlex, bt.alignCenter, bt.spaceBetween)}>{userName}<TableAction
              onClickDelete={() => this.deleteReview({ reviewId: value.id })}
              showDelete={true}
              showEdit={true}
              editLink={"/siteadmin/whyHost/review/edit/" + value.id}
            /> </div>
          },
          {
            data: reviewContent
          },
        ]
      }
    })
  }

  render() {
    const { currentPage } = this.state;
    const { reviewsManagement: { loading, getWhyHostAllReviews } } = this.props;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />;
    }

    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.WhyBecomeOwnerBlock6)}
          isLink
          href={`/siteadmin/whyHost/review/add`}
          redirectionLabel={formatMessage(messages.addNewLabel)}
          isSearch
          onSearch={this.handleSearchChange}
        />
        {
          !loading && getWhyHostAllReviews?.results?.length > 0 &&
          <CustomPagination
            total={getWhyHostAllReviews.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={this.paginationData}
            paginationLabel={formatMessage(messages.reviews)}
          />
        }
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  deleteWhyHostReview,
  demoRestriction
};

export default compose(injectIntl,
  withStyles(bt, s),
  connect(mapState, mapDispatch),
  withQuery(reviewsManagement, {
    name: 'reviewsManagement',
    options: (props) => ({
      variables: {
        currentPage: props.currentPage,
        searchList: props.searchList,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(AdminReviewsManagement);